// Simple localStorage cache with TTL (milliseconds)
type CacheValue<T> = {
  expiresAt: number;
  value: T;
};

const PREFIX = 'dw_cache_v1:';

export function setCache<T>(key: string, value: T, ttlMinutes = 15) {
  const expiresAt = Date.now() + ttlMinutes * 60 * 1000;
  const payload: CacheValue<T> = { expiresAt, value };
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(payload));
  } catch (e) {
    // localStorage may be full or disabled — fail silently
    console.warn('setCache failed', e);
  }
}

export function getCache<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as CacheValue<T>;
    if (!parsed || typeof parsed.expiresAt !== 'number') return null;
    if (Date.now() > parsed.expiresAt) {
      // expired
      localStorage.removeItem(PREFIX + key);
      return null;
    }
    return parsed.value;
  } catch (e) {
    console.warn('getCache failed', e);
    return null;
  }
}

export function clearCache(key: string) {
  try {
    localStorage.removeItem(PREFIX + key);
  } catch (e) {
    /* ignore */
  }
}

export function clearAllCache() {
  try {
    Object.keys(localStorage).forEach(k => {
      if (k.startsWith(PREFIX)) localStorage.removeItem(k);
    });
  } catch (e) { /* ignore */ }
}
